import React from 'react'
import { useDispatch } from 'react-redux'

import { toTemplates } from 'ducks/router'
import { useLocation } from 'hooks'
import { getDefaultQueryParams, getDetails, getTab, getTabs } from './model'

export const useInternalState = () => {
  const {
    payload: { id, tab: activeTab },
  } = useLocation()
  const dispatch = useDispatch()

  const detail = getDetails({ tab: activeTab })

  const tabs = getTabs()
  const tab = getTab({ tab: activeTab })

  const handleTabChange = React.useCallback(
    tab => {
      dispatch(toTemplates(tab, null, getDefaultQueryParams({ tab })))
    },
    [dispatch],
  )

  return {
    activeTab,
    detail,
    id,
    tab,
    tabs,
    handleTabChange,
  }
}
